import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmdNavbarItemModule } from './navbar-item/navbar-item.module';
import { AmdNavbarComponent } from './navbar.component';
export class AmdNavbarModule {
}
AmdNavbarModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, AmdNavbarItemModule],
                declarations: [AmdNavbarComponent],
                exports: [AmdNavbarComponent, AmdNavbarItemModule]
            },] },
];
/**
 * @nocollapse
 */
AmdNavbarModule.ctorParameters = () => [];
function AmdNavbarModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdNavbarModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdNavbarModule.ctorParameters;
}
//# sourceMappingURL=navbar.module.js.map
//# sourceMappingURL=navbar.module.js.map
